/* ==========================================================================
   Grippatch - motosiklet sahnesi

   Tek gorsel + motorun uzerinde UC nokta (depo / gosterge / arka jant).
   Yanip sonme tamamen CSS'te - JS'e is dusmuyor. Bu dosyanin isi:
     1) isaretci / dokunma / klavye ile ilgili nokta+kart ciftini ac-kapat
        (ayni anda yalnizca BIRI acik)
     2) o noktadan kendi kartina uzanan SVG cizginin koordinatlarini GERCEK
        eleman konumlarindan hesaplamak (duyarli yerlesimde sabit sayi ise
        yaramaz)

   Onceki surum tek noktaliydi ve durum bolum kokunde `.ms--acik` sinifiyla
   tutuluyordu; uc nokta icin yetmiyor - durum artik her grubun kendi
   elemanlarina `.acik` olarak veriliyor.

   Daha oncesinde 36 kareli bir dizi oynatiliyordu (canvas + rAF); o makine
   kaldirildi. Arsiv: `_archive/2026-08-17_moto360_kare_dizisi/`
   ========================================================================== */

(function () {
  'use strict';

  var kayit = [];

  function kur(kok) {
    if (kok.dataset.msKurulu === '1') return;
    kok.dataset.msKurulu = '1';

    var kutu = kok.querySelector('[data-ms-in]');
    var svg = kok.querySelector('[data-ms-svg]');
    var noktalar = kok.querySelectorAll('[data-ms-nokta]');
    if (!noktalar.length) return;

    var gruplar = [];
    for (var i = 0; i < noktalar.length; i++) {
      var n = noktalar[i].getAttribute('data-ms-nokta');
      var kart = kok.querySelector('[data-ms-kart="' + n + '"]');
      if (!kart) continue;
      gruplar.push({
        no: n,
        nokta: noktalar[i],
        nabiz: kok.querySelector('[data-ms-nabiz="' + n + '"]'),
        yol: kok.querySelector('[data-ms-yol="' + n + '"]'),
        uc: kok.querySelector('[data-ms-uc="' + n + '"]'),
        kart: kart,
        acik: false
      });
    }
    if (!gruplar.length) return;

    var kapatZaman = 0;
    var sonTip = 'mouse';

    /* --------------------------- baglanti cizgisi --------------------------- */

    function cizgiGuncelle(g) {
      if (!svg || !g.yol) return;
      var sr = svg.getBoundingClientRect();
      if (!sr.width || !sr.height) return;
      var nr = g.nokta.getBoundingClientRect();
      var kr = g.kart.getBoundingClientRect();

      svg.setAttribute('viewBox', '0 0 ' + sr.width + ' ' + sr.height);

      var x1 = nr.left + nr.width / 2 - sr.left;
      var y1 = nr.top + nr.height / 2 - sr.top;
      var kcx = kr.left + kr.width / 2 - sr.left;
      var kcy = kr.top + kr.height / 2 - sr.top;

      var x2;
      var y2;
      /* Kart yanda mi altta mi: GERCEK konuma bakilir, kirilim noktasina
         degil. Boylece CSS yerlesimi degisse de cizgi dogru yere baglanir. */
      var yatay = Math.abs(kcx - x1) > Math.abs(kcy - y1);
      if (yatay) {
        x2 = kcx < x1 ? kr.right - sr.left : kr.left - sr.left;
        y2 = kcy;
      } else {
        x2 = kcx;
        y2 = kcy < y1 ? kr.bottom - sr.top : kr.top - sr.top;
      }

      /* Yumusak tek bukumlu egri: noktadan yatay/dikey ayrilir, karta aciyla
         varir. Kalin/agresif degil - 1px. */
      var d = yatay
        ? 'M' + x1 + ',' + y1 + ' Q' + (x1 + (x2 - x1) * 0.5) + ',' + y1 + ' ' + x2 + ',' + y2
        : 'M' + x1 + ',' + y1 + ' Q' + x1 + ',' + (y1 + (y2 - y1) * 0.5) + ' ' + x2 + ',' + y2;
      g.yol.setAttribute('d', d);

      var uzunluk;
      try {
        uzunluk = g.yol.getTotalLength();
      } catch (e) {
        uzunluk = Math.abs(x2 - x1) + Math.abs(y2 - y1);
      }
      /* Uzunluk bolum kokune DEGIL yolun kendisine yaziliyor: her nokta
         kendi uzunlugunu tasimali, yoksa son acilan digerlerini bozar. */
      g.yol.style.setProperty('--ms-uzunluk', uzunluk);

      if (g.uc) {
        g.uc.setAttribute('cx', x2);
        g.uc.setAttribute('cy', y2);
      }
    }

    /* ------------------------------ ac / kapat ------------------------------ */

    function ac(g) {
      clearTimeout(kapatZaman);
      for (var i = 0; i < gruplar.length; i++) {
        if (gruplar[i] !== g && gruplar[i].acik) kapat(gruplar[i]);
      }
      if (g.acik) return;
      g.acik = true;
      g.nokta.classList.add('acik');
      g.kart.classList.add('acik');
      if (g.nabiz) g.nabiz.classList.add('acik');
      if (g.yol) g.yol.classList.add('acik');
      if (g.uc) g.uc.classList.add('acik');
      g.nokta.setAttribute('aria-expanded', 'true');
      /* Kart gorunur olduktan SONRA olculmeli; visibility gecisi 0s oldugu
         icin bir kare beklemek yeterli. */
      requestAnimationFrame(function () {
        cizgiGuncelle(g);
      });
    }

    function kapat(g) {
      if (!g.acik) return;
      g.acik = false;
      g.nokta.classList.remove('acik');
      g.kart.classList.remove('acik');
      if (g.nabiz) g.nabiz.classList.remove('acik');
      if (g.yol) g.yol.classList.remove('acik');
      if (g.uc) g.uc.classList.remove('acik');
      g.nokta.setAttribute('aria-expanded', 'false');
    }

    function hepsiniKapat() {
      for (var i = 0; i < gruplar.length; i++) kapat(gruplar[i]);
    }

    function gecikmeliKapat() {
      clearTimeout(kapatZaman);
      kapatZaman = setTimeout(hepsiniKapat, 140);
    }

    /* ------------------------------- olaylar ------------------------------- */

    gruplar.forEach(function (g) {
      g.nokta.addEventListener(
        'pointerdown',
        function (e) {
          sonTip = e.pointerType || 'mouse';
        },
        { passive: true }
      );

      g.nokta.addEventListener('pointerenter', function (e) {
        if ((e.pointerType || 'mouse') !== 'mouse') return;
        ac(g);
      });

      g.nokta.addEventListener('pointerleave', function (e) {
        if ((e.pointerType || 'mouse') !== 'mouse') return;
        gecikmeliKapat();
      });

      /* Kart noktanin DISINDA (masaustunde yanda). Fare noktadan karta
         giderken aradan cikar; kart uzerine girince kapanma iptal edilir,
         yoksa karttaki butona ulasilamaz. */
      g.kart.addEventListener('pointerenter', function (e) {
        if ((e.pointerType || 'mouse') !== 'mouse') return;
        clearTimeout(kapatZaman);
      });
      g.kart.addEventListener('pointerleave', function (e) {
        if ((e.pointerType || 'mouse') !== 'mouse') return;
        gecikmeliKapat();
      });

      /* Dokunma: dokunarak ac/kapat. Fareyle tiklamada zaten hover ile
         acilmis durumda - tekrar kapatmasin. */
      g.nokta.addEventListener('click', function (e) {
        if (sonTip === 'mouse') return;
        e.stopPropagation();
        if (g.acik) kapat(g);
        else ac(g);
      });

      /* Klavye: nokta gercek bir <button>, Enter/Space ac-kapat.
         `click` yolu isaretci tipine bakiyor; klavyede pointerType yok. */
      g.nokta.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        e.preventDefault();
        if (g.acik) kapat(g);
        else ac(g);
      });

      g.nokta.addEventListener('focus', function () {
        clearTimeout(kapatZaman);
      });
    });

    document.addEventListener('click', function (e) {
      if (sonTip === 'mouse') return;
      if (kutu && kutu.contains(e.target)) return;
      hepsiniKapat();
    });

    if (kutu) {
      kutu.addEventListener('focusin', function () {
        clearTimeout(kapatZaman);
      });
      kutu.addEventListener('focusout', function (e) {
        if (e.relatedTarget && kutu.contains(e.relatedTarget)) return;
        gecikmeliKapat();
      });
    }

    /* ----------------------------- boyut degisimi ---------------------------- */

    var ro = null;
    var yenidenOlc = function () {
      for (var i = 0; i < gruplar.length; i++) {
        if (gruplar[i].acik) cizgiGuncelle(gruplar[i]);
      }
    };
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(yenidenOlc);
      if (svg) ro.observe(svg);
      gruplar.forEach(function (g) {
        ro.observe(g.kart);
      });
    } else {
      window.addEventListener('resize', yenidenOlc);
    }

    kayit.push({
      kok: kok,
      temizle: function () {
        clearTimeout(kapatZaman);
        if (ro) ro.disconnect();
        else window.removeEventListener('resize', yenidenOlc);
      }
    });
  }

  function hepsi() {
    var liste = document.querySelectorAll('[data-moto-sahne]');
    for (var i = 0; i < liste.length; i++) kur(liste[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hepsi);
  } else {
    hepsi();
  }

  /* Tema editoru: bolum yeniden yuklenince tekrar kur, eskisini temizle. */
  document.addEventListener('shopify:section:load', hepsi);
  document.addEventListener('shopify:section:unload', function (e) {
    for (var i = kayit.length - 1; i >= 0; i--) {
      if (e.target.contains(kayit[i].kok)) {
        kayit[i].temizle();
        kayit.splice(i, 1);
      }
    }
  });
})();
